import React from 'react';

const Pricing = () => (
  <div className="w-full flex h-screen">
    <p className="m-auto">Pricing Page</p>
  </div>
);

export default Pricing;
